





import CreateReq from '@/components/orders/requester/create.vue';
import WorkerCreate from '@/components/orders/worker/create.vue';

import { Component, Vue } from 'vue-property-decorator';
import { User } from 'oidc-client';

@Component({ components: { CreateReq, WorkerCreate } })
export default class OrderCreate extends Vue {
  get currentUser(): User {
    return this.$store.state.user;
  }
}
